import { render, staticRenderFns } from "./ProductDetailImages.vue?vue&type=template&id=21af6790&"
import script from "./ProductDetailImages.js?vue&type=script&lang=js&"
export * from "./ProductDetailImages.js?vue&type=script&lang=js&"
import style0 from "./ProductDetailImages.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductDetailImages.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fproduct%2FProductDetailImages%2FProductDetailImages.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports